export default __webpack_public_path__ + "static/media/math.b80c2dda1954f3d720b4677b3db660fe.svg";